const Plus = (props) => {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='#152a46' {...props}>
      <path d='M5.865,5.865A19.265,19.265,0,0,1,20,0,19.265,19.265,0,0,1,34.135,5.865,19.265,19.265,0,0,1,40,20a19.265,19.265,0,0,1-5.865,14.135A19.265,19.265,0,0,1,20,40,19.265,19.265,0,0,1,5.865,34.135,19.265,19.265,0,0,1,0,20,19.265,19.265,0,0,1,5.865,5.865ZM30.288,22.019V17.981H22.019V9.712H17.981v8.269H9.712v4.038h8.269v8.269h4.038V22.019Z' />
    </svg>
  )
}

export default Plus
